<template>
  <v-container>
    <ProcessInvestigator
      v-if="
        this.$route.params.object_type === 'investigator' &&
          this.$route.params.form_name === 'personalForm'
      "
    />
    <ProcessExternalPeople
      v-else-if="
        this.$route.params.object_type === 'investigator' &&
          this.$route.params.form_name === 'externalPeopleForm'
      "
    />
    <ProcessNewInvestigator
      v-else-if="
        this.$route.params.object_type === 'investigator' &&
          this.$route.params.form_name === 'newInvestigatorForm'
      "
    />
    <ProcessNewVinculation
      v-else-if="
        this.$route.params.object_type === 'investigator' &&
          this.$route.params.form_name === 'vinculationForm'
      "
    />
    <ProcessModifyResponsible
      v-else-if="
        this.$route.params.object_type === 'investigator' &&
          this.$route.params.form_name === 'modifyResponsibleForm'
      "
    />
    <ProcessModifyVinculation
      :object_type="$route.params.object_type"
      v-else-if="
        this.$route.params.object_type === 'investigator' &&
          this.$route.params.form_name === 'modifyVinculationForm'
      "
    />
    <ProcessAnyConflict
      :object_type="$route.params.object_type"
      v-else-if="
        this.$route.params.object_type === 'investigator' &&
          this.$route.params.form_name === 'modifyExpirationDateForm'
      "
    />
    <ProcessAnyConflict
      :object_type="$route.params.object_type"
      v-else-if="
        this.$route.params.object_type === 'investigator' &&
          (this.$route.params.form_name === 'modifyServicesForm'
          || this.$route.params.form_name === 'affiliationForm')
      "
    />
    <ProcessWorkplaceAssignationForm
      v-else-if="
        this.$route.params.object_type === 'investigator' &&
          (this.$route.params.form_name === 'workplaceAssignationForm' ||
            this.$route.params.form_name === 'modifyWorkplaceForm')
      "
    />
    <ProcessAnyConflict
      :object_type="$route.params.object_type"
      v-else-if="this.$route.params.form_name === 'deleteRequest'"
    />
    <ProcessNewArticle
      v-else-if="this.$route.params.form_name === 'newArticleForm'"
    />
    <ProcessModifyBasicData
      v-else-if="
        this.$route.params.object_type === 'publication' &&
          this.$route.params.form_name === 'modifyBasicDataForm'
      "
    />
    <ProcessNewBookAndchapter
      v-else-if="
        this.$route.params.object_type === 'publication' &&
          (this.$route.params.form_name === 'newBookAndChapterForm')
      "
    />
    <ProcessNewThesis
            v-else-if="
        this.$route.params.object_type === 'publication' &&
          (this.$route.params.form_name === 'newThesisForm')
      "
    />
    <ProcessCommunication
      v-else-if="
        this.$route.params.object_type === 'publication' &&
          this.$route.params.form_name === 'newCommunicationForm'
      "
    />
    <ProcessProject v-else-if="
        this.$route.params.object_type === 'project' &&
          (this.$route.params.form_name === 'newProjectForm' || this.$route.params.form_name === 'modifyProjectForm')
      "
    />
    <ProcessAnyConflict
        :object_type="$route.params.object_type"
        v-else-if="
        this.$route.params.object_type === 'news'
      "
    />
    <ProcessStay
      v-else-if="
        this.$route.params.object_type === 'stay'
      "
    />
    <ProcessSoftware
      v-else-if="this.$route.params.object_type === 'software'"
    />
    <ProcessDataset
      v-else-if="this.$route.params.object_type === 'dataset'"
    />
    <ProcessIndustrialProperty
      v-else-if="this.$route.params.object_type === 'industrial_property'"
    />
  </v-container>
</template>

<script>
import ProcessInvestigator from "../components/investigators/processors/ProcessInvestigator";
import ProcessExternalPeople from "../components/investigators/processors/ProcessExternalPeople";
import ProcessNewInvestigator from "../components/investigators/processors/ProcessNewInvestigator";
import ProcessNewVinculation from "../components/investigators/processors/ProcessNewVinculation";
import ProcessModifyVinculation from "../components/investigators/processors/ProcessModifyVinculation";
import ProcessAnyConflict from "../components/investigators/processors/ProcessAnyConflict";
import ProcessModifyResponsible from "../components/investigators/processors/ProcessModifyResponsible";
import ProcessWorkplaceAssignationForm from "../components/investigators/processors/ProcessWorkplaceAssignationForm";
import ProcessNewArticle from "../components/publications/processors/ProcessNewArticle";
import ProcessModifyBasicData from "../components/publications/processors/ProcessModifyBasicData";
import ProcessNewBookAndchapter from "../components/publications/processors/ProcessNewBookAndchapter";
import ProcessCommunication from "../components/publications/processors/ProcessCommunication";
import ProcessNewThesis from "../components/publications/processors/ProcessNewThesis";
import ProcessProject from "../components/projects/processors/ProcessProject";
import ProcessStay from "../components/stays/processors/ProcessStay";
import ProcessSoftware from "@/components/software/processors/ProcessSoftware.vue";
import ProcessDataset from "@/components/datasets/processors/ProcessDataset.vue";
import ProcessIndustrialProperty from "@/components/industrialProperty/processors/ProcessIndustrialProperty.vue";
export default {
  name: "Reviews",
  components: {
    ProcessIndustrialProperty,
    ProcessDataset,
    ProcessSoftware,
    ProcessNewArticle,
    ProcessNewVinculation,
    ProcessInvestigator,
    ProcessExternalPeople,
    ProcessNewInvestigator,
    ProcessAnyConflict,
    ProcessModifyResponsible,
    ProcessWorkplaceAssignationForm,
    ProcessModifyBasicData,
    ProcessNewBookAndchapter,
    ProcessCommunication,
    ProcessNewThesis,
    ProcessModifyVinculation,
    ProcessProject,
    ProcessStay
  },
  created() {
    let item = {
      text: "section." + this.$route.params.form_name,
      disabled: true,
      last: true
    };
    if (
      !this.$route.meta.breadCrumb.some(breadcrumb => {
        return breadcrumb.last === true;
      })
    ) {
      this.$route.meta.breadCrumb.push(item);
    } else {
      this.$route.meta.breadCrumb.pop();
      this.$route.meta.breadCrumb.push(item);
    }
    this.$store.state.sectionTitle = "section." + this.$route.params.form_name;
  }
};
</script>
